export default __webpack_public_path__ + "static/media/featured.9fd0ba5f.svg";